export default __webpack_public_path__ + "static/research-hero-e922521d8d9755f982cc7684e52b239b.jpg";